import { FormlyFieldConfig } from '@ngx-formly/core';
import { DspxCardSetBaseFormComponent, FIELD_TYPE } from 'dspx-core';

import { QuestionPath } from './config-data-parser';

import { FormConfigurationParserService } from '../services/form-configuration-parser.service';
import { ResponseParserService } from '../services/response-parser.service';

type FileUploadQuestionDetail = {
  questionPath: QuestionPath;
  questionConfig: FormlyFieldConfig;
};

export class FileUploadHelper {

  static getFileUploadQuestionPathsAndConfigs(
    formConfigurationParserService: FormConfigurationParserService,
    baseForm: DspxCardSetBaseFormComponent
  ): FileUploadQuestionDetail[] {

    return formConfigurationParserService.getQuestionPaths(baseForm.fields)
      ?.map(questionPath => {
        const questionConfig = formConfigurationParserService.findQuestionConfig(
          baseForm.fields,
          ...questionPath
        );

        return {
          questionPath,
          questionConfig
        };
      })
      ?.filter(question => question.questionConfig?.type === FIELD_TYPE.file)
      ?? [];
  }

  static getFileUploadQuestionGetModelFunctions(
    formConfigurationParserService: FormConfigurationParserService,
    responseParserService: ResponseParserService,
    baseForm: DspxCardSetBaseFormComponent
  ): { getQuestionModels: (model: any) => string[] }[] {

    const fileUploadQuestions = this.getFileUploadQuestionPathsAndConfigs(
      formConfigurationParserService,
      baseForm
    );

    return fileUploadQuestions.map(question => {
      const [navTabNumber, pageNumber, sectionCode, questionCode] = question.questionPath;
      const isRepeatingPage = !!question.questionConfig?.props?.isRepeatingPage;
      const isRepeatingSection = !!question.questionConfig?.props?.isRepeatingSection;

      return {
        getQuestionModels: (model: any) =>
          responseParserService.findQuestionItems(
            model,
            navTabNumber,
            pageNumber,
            isRepeatingPage,
            sectionCode,
            isRepeatingSection,
            questionCode
          )?.map(item => item.questionModel) ?? []
      };
    });
  }
}
